const PURCHASE_ORDER_PATTERN = /\bSOL\d{7,}\b/g;

export function extractPurchaseOrderCandidates(
  memoLine: string | null
): string[] {
  if (!memoLine) return [];

  const matches = memoLine.toUpperCase().match(PURCHASE_ORDER_PATTERN) ?? [];

  return Array.from(new Set(matches));
}
